module.exports = __webpack_public_path__ + "img/coming-soon.2bd345f6.png";